<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="未结算介绍费" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms" size="mini">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" filterable clearable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item label="介绍类型">
                    <el-radio-group v-model="searchParms.type" @change="typeChange">
                        <el-radio :label="0">员工</el-radio>
                        <el-radio :label="1">第三方</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboNotDePositData" size="mini" style="text-align: center" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        {{scope.row.parentname}}/{{scope.row.storename}}
                    </template>
                </el-table-column>
                <el-table-column label="介绍人"  align="center" prop="jstor">
                    <template slot-scope="scope">
                        <span v-if="scope.row.staffname">{{scope.row.staffname}}</span>
                        <span v-else>{{scope.row.jstor}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="介绍费"  align="center" prop="jsamount"></el-table-column>
                <el-table-column label="操作"  align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="openIntroduce(scope)" :loading="queryLoadBtton" type="text" size="small">结算</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="支付" :visible.sync="dialogVisible" width="100%" top="10px" class="notpay" :close-on-click-modal="false">
            <el-form :model="intebointroduce" size="mini" label-width="80px">
                <el-form-item label="门店">
                    {{intebointroduce.parentname}}/{{intebointroduce.storename}}
                </el-form-item>
                <el-form-item label="SN">
                    {{intebointroduce.sn}}
                </el-form-item>
                <el-form-item label="仪器型号">
                    {{intebointroduce.yqmodel}}
                </el-form-item>
                <el-form-item label="介绍费">
                    {{intebointroduce.jsamount}}
                </el-form-item>
                <el-form-item label="支付日期">
                    <el-date-picker size="mini" :editable="false" style="width: 100%" v-model="intebointroduce.accountdate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="updateInteboIntroduce()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            queryLoadBtton:false,
            curIndex:0,
            intebointroduce:{
                parentname:"",
                storename:"",
                sysbillid:"",
                accountdate:"",
                sn:"",
                yqmodel:"",
                jsamount:0,
            },
            dialogVisible:false,
            storeData:[],
            inteboNotDePositData:[],
            searchParms:{
                parentid:"",
                storeid:"",
                type:0,
            },
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboSendByFinished();
    },
    methods:{
        typeChange(){
            this.getInteboSendByFinished();
        },
        updateInteboIntroduce(){
            this.queryLoadBtton=true;
            this.$postw("intebosale/updateInteboIntroduce",this.intebointroduce).then(res=>{
                this.queryLoadBtton=false;
                if(res.sucess){
                    this.dialogVisible=false;
                    this.getInteboSendByFinished();
                }
            });
        },
        openIntroduce(scope){
            this.dialogVisible=true;
            this.curIndex=scope.$index;
            this.intebointroduce=scope.row;
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[1]){
                this.searchParms.parentid=val[0];
                this.searchParms.storeid=val[1];
            }
            else{
                if(val[0]){
                    this.searchParms.parentid=val[0];
                }
            }
            this.getInteboSendByFinished();
        },
        getInteboSendByFinished(){
            this.$post("intebosale/getInteboIntroduceByFinished",{parentid: this.searchParms.parentid,storeid:this.searchParms.storeid,type:this.searchParms.type}).then(res=>{
                this.inteboNotDePositData=res.object;
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.notpay .el-input-number .el-input__inner {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/notintroduce.vue